import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import qs from 'query-string';
import dayjs from 'dayjs';

import getEnvConfig from 'utils/config/env';

import { FinanceTableProps, IStatisticFinance } from './finance.interface';
import { AnalyticsFiltersProps } from '../../AnalyticsFilters/service/filters.interface';
import { DATE_TIME_SECONDS } from '../../../../../shared/contants/date';

export const analyticsFinanceApi = createApi({
    reducerPath: 'analyticsFinance',
    baseQuery: fetchBaseQuery({
        baseUrl: getEnvConfig().env.API_URL,
        prepareHeaders: headers => {
            const token = localStorage.getItem('accessToken');
            headers.set('Authorization', `Bearer ${token}`);
            return headers;
        },
    }),
    tagTypes: ['AnalyticsFinance'],
    endpoints: builder => ({
        getFinancePaymentHistory: builder.query<
            FinanceTableProps[],
            AnalyticsFiltersProps
        >({
            query: args => {
                const queryArgs = qs.stringify(args, {
                    skipEmptyString: true,
                    skipNull: true,
                });
                return {
                    url: `/statistic/payments-list?${queryArgs}`,
                    method: 'GET',
                };
            },
            transformResponse: (response: { data: FinanceTableProps[] }) => {
                return response.data.map(d => ({
                    ...d,
                    photo_url: d.photo_url
                        ? `${getEnvConfig().env.API_URL.replace(
                              /api\/v3/,
                              ''
                          )}${d.photo_url}`
                        : null,
                    buy_date: dayjs(d.buy_date, DATE_TIME_SECONDS).valueOf(),
                }));
            },
        }),
        getFinance: builder.query<IStatisticFinance, AnalyticsFiltersProps>({
            query: args => {
                const queryArgs = qs.stringify(args, {
                    arrayFormat: 'bracket-separator',
                    skipEmptyString: true,
                    skipNull: true,
                });
                return {
                    url: `/statistic/payments-charts?${queryArgs}`,
                    method: 'GET',
                };
            },
            transformResponse: (response: any) => {
                return {
                    balance: response.items.balance,
                    course: response.items.course_balance,
                    donate: response.items.donate_balance,
                    rate: response.items.tariff_balance,
                    labels: response.meta.marks.map(label =>
                        dayjs(label.split(' ')[0]).valueOf()
                    ),
                    all: response.meta.all,
                };
            },
        }),
    }),
});

export const { useLazyGetFinanceQuery, useLazyGetFinancePaymentHistoryQuery } =
    analyticsFinanceApi;
